module.exports = __webpack_public_path__ + "img/news-01.b9cc0ae8.jpg";